import { useTranslation, Trans } from '@packlink/translation-provider';
import { Typography, Next, InlineNotification, NotificationType } from '@shipengine/giger';
import { CustomsSection } from '../Partials/CustomsSection.js';
import { useHelpCenter, HELP_CENTER_KEYS } from '@packlink/provider';
import { getCustomsDeclarationTitleStyles } from './CustomsDeclarationStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

function CustomsDeclaration(_ref) {
  let {
    showWindsorWarning = true,
    ...props
  } = _ref;
  const {
    t
  } = useTranslation();
  const getHelpCenterPage = useHelpCenter();
  const customsSupportLink = getHelpCenterPage(HELP_CENTER_KEYS.customsInvoices);
  const windsorDisclaimerLink = getHelpCenterPage(HELP_CENTER_KEYS.windsorFramework);
  return jsxs(CustomsSection, {
    title: t('customs-form.customs-declaration.title'),
    ...props,
    children: [jsxs(Typography, {
      component: "p",
      variant: "body1",
      css: getCustomsDeclarationTitleStyles,
      children: [jsx(Trans, {
        i18nKey: "customs-form.header.introduction"
      }), ' ', jsx(Next.Link, {
        href: customsSupportLink,
        target: "_blank",
        isExternal: true,
        children: t('customs-form.header.helplink')
      })]
    }), jsx(InlineNotification, {
      type: NotificationType.INFO,
      children: showWindsorWarning ? jsx(Trans, {
        i18nKey: "customs-form.header.windsor-disclaimer",
        components: [jsx(Next.Link, {
          target: "_blank",
          href: windsorDisclaimerLink
        }, "windsor-link")]
      }) : t('customs-form.header.disclaimer')
    })]
  });
}

export { CustomsDeclaration };
//# sourceMappingURL=CustomsDeclaration.js.map
